export const customerApplication = {
  analytics: {
    heap: true,
    googleTagManager: true
  },
  header: {
    questions: true,
    contactUs: null,
    show_badge: false
  },
  sidebar: {
    images: {
      security: require('@amount/frontend-styles/src/images/dec/dec-thumb-seal-small.png'),
      questions: require('@amount/frontend-styles/src/images/dec/dec-thumb-help-small.png'),
      better_business_bureau: require("@amount/frontend-styles/src/images/partners/avant/logo/logo-bbb.png"),
      questions: require('@amount/frontend-styles/src/images/dec/dec-thumb-help-small.png'),
    },
    digicert: true
  },
  useAmountModalForSessionExpiry: false,
};

export const ipDash = {
  analytics: {
    heap: true,
    googleTagManager: false
  }
};

export const customerHome = {
  analytics: {
    heap: true,
    googleTagManager: true
  }
};

require("!!inline-loader!@amount/frontend-styles/src/images/partners/avant/icons/icon-map.svg");
